(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawro-checkout-preview"] && !Shopify.designMode) return;
  try {
    
  /* =====================================================================
     Pawro Checkout Design Preview — presentation logic only.

     This script never touches /cart, /checkout, the Cart AJAX API or any
     form submission. It only moves between visual panes and recomputes
     illustrative totals from a subtotal handed to it by Liquid.
     ===================================================================== */
  (function () {
    var root = document.querySelector('.pawro-cop');
    if (!root || root.dataset.copReady) return;
    root.dataset.copReady = '1';

    var cfg = JSON.parse(root.querySelector('[data-cop-config]').textContent);
    var q = function (s, c) { return (c || root).querySelector(s); };
    var qa = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
    var cents = function (n) { return Math.round(n); };

    /* Format using the shop's own money format so the preview always
       matches the currency the rest of the theme renders. */
    function money(c) {
      return cfg.symbol + (c / 100).toFixed(2);
    }

    var step = 1, ship = null, disc = null;

    function totals(animate) {
      var sub = cfg.subtotal;
      var d = disc ? cents(sub * cfg.codes[disc].off) : 0;
      var net = cents(sub - d);
      var sc = ship === null ? null
             : (Number(ship) === 0 ? (net >= cfg.freeOver ? 0 : cfg.standardFee) : Number(ship));
      var tax = cents((net + (sc || 0)) * cfg.taxRate);
      var tot = cents(net + (sc || 0) + tax);

      q('[data-cop-sub]').textContent = money(sub);
      q('[data-cop-drow]').classList.toggle('is-on', !!disc);
      q('[data-cop-dval]').textContent = '−' + money(d);

      var shp = q('[data-cop-shp]');
      shp.textContent = sc === null ? 'Calculated at next step' : (sc === 0 ? 'FREE' : money(sc));
      shp.style.color = sc === 0 ? '#3d8560' : '';

      var std = q('[data-cop-std]');
      if (std) {
        var free = net >= cfg.freeOver;
        std.textContent = free ? 'FREE' : money(cfg.standardFee);
        std.classList.toggle('is-free', free);
      }

      q('[data-cop-tax]').textContent = money(tax);
      q('[data-cop-tot]').textContent = money(tot);
      q('[data-cop-mtot]').textContent = money(tot);
      var ctaTot = q('[data-cop-ctatot]');
      if (ctaTot) ctaTot.textContent = money(tot);

      if (animate) {
        var t = q('[data-cop-tot]');
        t.classList.remove('is-tick');
        void t.offsetWidth;
        t.classList.add('is-tick');
      }
    }

    function validate(from) {
      if (from !== 1) return true;
      var input = q('#cop-em');
      var field = input.closest('.pawro-cop__f');
      var ok = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(input.value.trim());
      field.classList.toggle('pawro-cop__f--err', !ok);
      field.classList.toggle('pawro-cop__f--ok', ok);
      if (!ok) input.focus();
      return ok;
    }

    function recap() {
      var em = q('#cop-em').value.trim() || '—';
      var name = [q('#cop-fn').value, q('#cop-ln').value].filter(Boolean).join(' ');
      var bits = [name, q('#cop-a1').value, q('#cop-ct').value].filter(Boolean);
      var ad = bits.length ? bits.join(', ') : '—';
      var sn = ship === null ? '—'
             : Number(ship) === 0 ? 'Standard · 4–7 days'
             : Number(ship) === 999 ? 'Express · 2–3 days' : 'Priority · 1–2 days';
      qa('[data-cop-r="em"]').forEach(function (e) { e.textContent = em; });
      qa('[data-cop-r="ad"]').forEach(function (e) { e.textContent = ad; });
      qa('[data-cop-r="sh"]').forEach(function (e) { e.textContent = sn; });
    }

    function go(n) {
      if (n > step && !validate(step)) return;
      step = n;
      qa('[data-cop-pane]').forEach(function (p) {
        p.classList.toggle('is-on', Number(p.dataset.copPane) === n);
      });
      qa('.pawro-cop__step-i').forEach(function (s, i) {
        s.classList.toggle('is-on', i + 1 === n);
        s.classList.toggle('is-done', i + 1 < n);
      });
      recap();

      /* Horizon scrolls .page-wrapper, not the window — scroll whichever
         ancestor actually owns the scrollbar, then fall back to window. */
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var behavior = reduce ? 'auto' : 'smooth';
      var scroller = root.closest('.page-wrapper');
      var top = root.getBoundingClientRect().top;
      if (scroller && scroller.scrollHeight > scroller.clientHeight) {
        scroller.scrollTo({ top: scroller.scrollTop + top - 20, behavior: behavior });
      } else {
        window.scrollTo({ top: window.pageYOffset + top - 20, behavior: behavior });
      }
    }

    qa('[data-cop-next]').forEach(function (b) {
      b.addEventListener('click', function () { go(Number(b.dataset.copNext)); });
    });
    qa('[data-cop-back]').forEach(function (b) {
      b.addEventListener('click', function () { go(Number(b.dataset.copBack)); });
    });
    qa('input[name="cop-sh"]').forEach(function (r) {
      r.addEventListener('change', function () { ship = r.value; totals(true); recap(); });
    });

    q('#cop-em').addEventListener('blur', function () {
      if (q('#cop-em').value.trim()) validate(1);
    });

    var applyBtn = q('[data-cop-apply]');
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        var input = q('[data-cop-dc]');
        var code = input.value.trim().toUpperCase();
        if (cfg.codes[code]) {
          disc = code;
          q('[data-cop-dtagt]').textContent = cfg.codes[code].label;
          q('[data-cop-dtag]').classList.add('is-on');
          input.value = '';
          totals(true);
        } else {
          input.style.borderColor = '#e8879a';
          input.value = '';
          input.placeholder = 'That code isn’t recognised';
          setTimeout(function () {
            input.style.borderColor = '';
            input.placeholder = 'Discount code';
          }, 2200);
        }
      });
    }

    var place = q('[data-cop-place]');
    if (place) {
      place.addEventListener('click', function () {
        place.disabled = true;
        place.style.opacity = '0.8';
        place.textContent = 'Design preview — no order was created';
      });
    }

    var msum = q('[data-cop-msum]');
    if (msum) {
      msum.addEventListener('click', function () {
        msum.classList.toggle('is-on');
        q('[data-cop-sum]').classList.toggle('is-on');
      });
    }

    totals(false);
    recap();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawro-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__pawroContact) return;
    window.__pawroContact = true;
    /* "Sending..." state on the contact submit — visual only, never blocks
       the native submission (button is soft-locked a tick later) */
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.pawro-ct__form');
      if (!form) return;
      var button = form.querySelector('.pawro-ct__submit');
      if (!button || button.classList.contains('is-sending')) return;
      button.classList.add('is-sending');
      button.setAttribute('aria-busy', 'true');
      var label = button.querySelector('.pawro-ct__submit-label');
      if (label) label.textContent = button.dataset.sendingText || 'Sending...';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawro-featured"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-halloween-spider')) {
    customElements.define('pf-halloween-spider', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-arrived') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const header = this.closest('.pawro-featured--halloween')?.querySelector('.pawro-featured__header');
        if (!header || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.setAttribute('data-arrived', '');
            this.observer.disconnect();
          }
        }, { threshold: .35 });
        this.observer.observe(header);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
